import { Locale } from 'vant';
import enUS from 'vant/es/locale/lang/en-US';
import jaJP from 'vant/es/locale/lang/ja-JP';
import zhCN from 'vant/es/locale/lang/zh-CN';
import zhTW from 'vant/es/locale/lang/zh-TW';
import viVN from 'vant/es/locale/lang/vi-VN';

function setVantLang(lang) {
    if (!lang) lang = en

    switch (lang) {
        case 'ja':
            Locale.use('ja-JP', jaJP);
            break;

        case 'cn':
            Locale.use('zh-CN', zhCN);
            break;

        case 'tw':
            Locale.use('zh-TW', zhTW);
            break;

        case 'vi':
            Locale.use('vi-VN', viVN);
            break;

        default:
            Locale.use('en-US', enUS);
            break;
    }
}

export default setVantLang